export * from './typings';
export function addScript(f, b, e, v, n, t, s) {
  if (f.fbq) {
    return f.fbq;
  }
  n = f.fbq = function () {
    if (n.callMethod) {
      n.callMethod.apply(n, arguments);
    } else {
      n.queue.push(arguments);
    }
  };
  if (!f._fbq) {
    f._fbq = n;
  }
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
  return n;
}
export function addScriptDefault() {
  return addScript(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
}
export function setup() {
  var $fbq = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : addScriptDefault();
  function init(pixelId) {
    var autoconfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $fbq('set', 'autoConfig', autoconfig, pixelId);
    $fbq('init', pixelId);
    return setup($fbq);
  }
  function pageView(pixelId) {
    if (pixelId === undefined) {
      $fbq('track', 'PageView');
    } else {
      $fbq('trackSingle', pixelId, 'PageView');
    }
    return setup($fbq);
  }
  return {
    $fbq: $fbq,
    init: init,
    pageView: pageView
  };
}